/*
 *
 * ColorsPanel constants
 *
 */

import { Position, PositionAngle } from 'lib/modelBuilder/constants';
import { Color } from 'lib/modelBuilder/entities/Color';

enum ActionTypes {
  DISPLAY_COLORS_PANEL = 'app/ColorsPanel/DISPLAY_COLORS_PANEL',

  UPDATE_COLOR_PANE_ON_SELECTION = 'app/ColorsPanel/UPDATE_COLOR_PANE_ON_SELECTION',
  UPDATE_COLOR_PANE_ON_SELECTION_FAILURE = 'app/ColorsPanel/UPDATE_COLOR_PANE_ON_SELECTION_FAILURE',
}

export default ActionTypes;

export interface PieceSelectionData {
  title: string;
  shortTitle?: string;
  position: Position | PositionAngle;
  color: Color | null;
}
